import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'hotel',
	state : {
		hotels: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/hotels') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Hotel', {skip: 0, limit: limit, count: 1, order: '-createdAt'})
				const hotels = resp.results;

				yield put({ type: 'queryFirst', payload: {
					hotels: hotels, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Hotel', payload)
				const hotels = resp.results;

				yield put({ type: 'querySuccess', payload: {
					hotels: hotels,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'Hotel', payload.objectId, data);
				yield put({ type: 'updateSuccess', payload: {...data, objectId: payload.objectId} })
				message.success('Se ha actualizado el hotel exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Hotel', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				hotels: state.hotels.concat(action.payload.hotels),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.hotels, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			hotels: _.without(state.hotels, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/hotel.js